import {
  GET_ENTRY_STRATEGY_BY_ID,
  GET_ENTRY_STRATEGY_BY_ID_FAILED,
  GET_ENTRY_STRATEGY_BY_ID_SUCCESSFUL,
} from './actionTypes';

const initialState = {
  entryStrategy: null,
  getEntryStrategyByIdError: null,
  loadingGetEntryStrategyById: false,
  successGetEntryStrategy: '',
};

const getEntryStrategyById = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTRY_STRATEGY_BY_ID:
      state = {
        ...state,
        loadingGetEntryStrategyById: true,
        getEntryStrategyByIdError: null,
        successGetEntryStrategy: '',
      };
      break;
    case GET_ENTRY_STRATEGY_BY_ID_SUCCESSFUL:
      state = {
        ...state,
        loadingGetEntryStrategyById: false,
        entryStrategy: action.payload,
        getEntryStrategyByIdError: null,
        successGetEntryStrategy: action.payload.message,
      };
      break;
    case GET_ENTRY_STRATEGY_BY_ID_FAILED:
      state = {
        ...state,
        entryStrategy: null,
        loadingGetEntryStrategyById: false,
        getEntryStrategyByIdError: action.payload,
        successGetEntryStrategy: '',
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getEntryStrategyById;
